import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import TopicBlock from './TopicBlock';
import s from './Topics.scss';
const Topics = ({ block, deviation: parentDeviation })=>{
    var _block_topics, _block_topics1;
    if (!((_block_topics = block.topics) === null || _block_topics === void 0 ? void 0 : _block_topics.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block,
        headerClassName: s['header']
    }, /*#__PURE__*/ React.createElement("div", null, (_block_topics1 = block.topics) === null || _block_topics1 === void 0 ? void 0 : _block_topics1.map(({ itemId, name, url, exampleDeviations })=>name && url && exampleDeviations && exampleDeviations.length > 0 && /*#__PURE__*/ React.createElement(TopicBlock, {
            key: itemId,
            topicId: itemId,
            parentDeviation: parentDeviation,
            title: name,
            deviations: exampleDeviations,
            linkTo: url
        }))));
};
Topics.displayName = 'Topics';
export default Topics;
